import { normalize } from 'normalizr';
import { query, mutation } from '@/dex-shared/helpers/graphql';
import { examGroup } from '@/dex-shared/helpers/normalizr_schema';
import UEEPegasusPangareRequestService from '@/helpers/pegasus-pangare/request';

const weeklyAssessmentIdentifier = '[MATEMATICA|NATUREZA|HUMANAS|LINGUAGENS]';

export default {
  async PULL_EXAM_GROUPS({ commit }: any, currentPage: number = 0) {
    const resultsPerPage = 50;
    const offset = resultsPerPage * currentPage;
    const response = await query(
      `query getExamGroupsDexAdmin($resultsPerPage: Int, $offset: Int) {
      allExamGroups(first: $resultsPerPage, offset: $offset, orderBy: ID_DESC) {
        nodes {
          id
          name
          payerOnly
          examGroupsExamsByExamGroupId {
            totalCount
          }
          materialsByExamGroupId {
            nodes {
              id
              examGroupId
              boardByBoardId {
                id
                title
              }
            }
          }
        }
      }
    }`,
      {
        resultsPerPage,
        offset,
      },
    );
    const normalizedResponse = normalize(response.data.allExamGroups.nodes, [
      examGroup,
    ]);
    commit('CLEAN_STATE', 'exam_groups');
    commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
  },
  async REMOVE_EXAM_GROUP({ commit }: any, examGroupId: number) {
    try {
      //TODO remove material and board entries

      const examGroupResponse = await query(
        `
          query pullExamGroup($examGroupId: Int!) {
            examGroupById(id: $examGroupId) {
              id
              name
              slug
              examGroupsExamsByExamGroupId(orderBy: EXAM_BY_EXAM_ID__START_ASC) {
                nodes {
                  examByExamId {
                    id
                    start
                    description
                  }
                }
              }
            }
          }
        `,
        { examGroupId: +examGroupId },
      );

      let examGroupsExamsResponse = await query(
        `
        query getExamGroupsExamsIds ($examGroupId: Int!) {
          examGroupById(id: $examGroupId) {
            examGroupsExamsByExamGroupId {
              nodes {
                id
              }
            }
          }
        }
        `,
        {
          examGroupId: +examGroupId,
        },
      );

      let examGroupsExams =
        examGroupsExamsResponse.data.examGroupById.examGroupsExamsByExamGroupId
          .nodes;

      //Deleting all exam groups exams
      let deleteExamGroupsExamsResponse = await mutation(
        `mutation deleteMultipleExamGroupsExams {
          ${examGroupsExams.map(
            (
              examGroupsExam: any,
              index: number,
            ) => `examGroupsExams${index}: deleteExamGroupsExamById(input: {
              id: ${examGroupsExam.id}
            }) {
              examGroupsExam {
                id
              }
            }`,
          )}
        }`,
      );

      //Delete the examGroup
      let response = await mutation(
        `mutation deleteExamGroup($examGroupId: Int!) {
          deleteExamGroupById(input: {
            id: $examGroupId
          }) {
            examGroup {
              id
            }
          }
        }`,
        {
          examGroupId: +examGroupId,
        },
      );

      await deleteUeeCalendarEvents(examGroupResponse.data.examGroupById);
      return true;
    } catch (err) {
      return err;
    }
  },
};

const deleteUeeCalendarEvents = async (
  deletedExamGroup: any,
): Promise<void> => {
  if (!deletedExamGroup.slug) return;

  let errorOnUpdateUEECalendar = false;
  const examsData = deletedExamGroup.examGroupsExamsByExamGroupId.nodes || [];

  const deleteEventsProcess = examsData.map(async examData => {
    const exam = examData.examByExamId;

    if (
      exam &&
      exam.description.toUpperCase().includes(weeklyAssessmentIdentifier)
    ) {
      const result = await UEEPegasusPangareRequestService.deletePracticeExamCalendarEvents(
        {
          practiceExamId: exam.id,
          practiceExamStartDate: exam.start,
          dexExamGroups: [deletedExamGroup.slug],
        },
      );

      if (result.identifier !== 'CalendarEventDeleted')
        errorOnUpdateUEECalendar = true;
    }
  });

  await Promise.all(deleteEventsProcess);

  if (errorOnUpdateUEECalendar)
    alert('Erro ao atualizar os eventos na agenda de UEE.');
};
